import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Table, Pager, Tabs, Chip, Person, img, fmt, when } from "./kit";
import ClanAdmin from "./ClanAdmin";

const SocialAdmin = () => {
  const [tab, setTab] = useState("clans");
  const [page, setPage] = useState(1);
  const [q, setQ] = useState("");
  const [state, setState] = useState("active");
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (tab === "clans") return;
    setLoading(true);
    const res = tab === "families" ? await api.families({ page, size: 20, q }) : await api.marriages({ page, size: 20, state });
    if (res?.status) setData(res);
    setLoading(false);
  }, [tab, page, q, state]);

  useEffect(() => {
    load();
  }, [load]);

  const famAct = async (f, action) => {
    let body = { action };
    if (action === "edit") {
      const name = window.prompt("Aile adı", f.name);
      if (name === null) return;
      const notice = window.prompt("Aile duyurusu", f.notice || "");
      if (notice === null) return;
      body = { action, name, notice };
    }
    if (action === "addMember") {
      const code = window.prompt(`"${f.name}" ailesine eklenecek kullanıcının ID'si:`, "");
      if (!code) return;
      body = { action, code: code.trim() };
    }
    if (action === "delete" && !window.confirm(`"${f.name}" ailesi ve tüm üyelikleri silinsin mi?`)) return;
    const res = await api.familyAction(f._id, body);
    if (!res?.status) window.alert(res?.message || "İşlem başarısız");
    else if (res?.message && action === "addMember") window.alert(res.message);
    load();
  };

  const endMarriage = async (m) => {
    const reason = window.prompt(`${m.proposerName} ❤ ${m.partnerName} evliliği sonlandırılsın. Sebep:`, "");
    if (reason === null) return;
    await api.endMarriage(m._id, reason);
    load();
  };

  return (
    <>
      <PageHead title="Kabileler & Evlilikler" sub="Kabileleri yönet (üye ekle/çıkar, düzenle, yasakla, sil) ve evlilikleri sonlandır." />
      <Tabs value={tab} onChange={(t) => { setTab(t); setPage(1); setData({}); }} tabs={[["clans", "Kabileler"], ["marriages", "Evlilikler"], ["families", "Eski aileler"]]} />

      {tab === "clans" ? (
        <ClanAdmin />
      ) : tab === "families" ? (
        <>
          <input className="form-control" style={{ maxWidth: 260, marginBottom: 12 }} placeholder="Aile adı ara" value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} />
          <Table
            loading={loading}
            head={["Aile", "Kurucu", "Üye", "Seviye", "Puan", "Durum", ""]}
            rows={(data.families || []).map((f) => (
              <tr key={f._id}>
                <td>
                  <div className="d-flex align-items-center" style={{ gap: 8 }}>
                    {f.badge ? <img className="table_image" src={img(f.badge)} alt="" /> : null}
                    <b>{f.name}</b>
                  </div>
                </td>
                <td>{f.ownerName}</td>
                <td>
                  {f.memberCount}/{f.maxMembers}
                </td>
                <td>{f.level}</td>
                <td>{fmt(f.score)}</td>
                <td>{f.isBanned ? <Chip kind="bad">Yasaklı</Chip> : <Chip>Aktif</Chip>}</td>
                <td style={{ whiteSpace: "nowrap" }}>
                  <button className="btn btn-sm btn-outline-primary" onClick={() => famAct(f, "addMember")}>
                    Üye ekle
                  </button>{" "}
                  <button className="btn btn-sm btn-outline-secondary" onClick={() => famAct(f, "edit")}>
                    Düzenle
                  </button>{" "}
                  {f.isBanned ? (
                    <button className="btn btn-sm btn-outline-success" onClick={() => famAct(f, "unban")}>
                      Yasağı kaldır
                    </button>
                  ) : (
                    <button className="btn btn-sm btn-warning" onClick={() => famAct(f, "ban")}>
                      Yasakla
                    </button>
                  )}{" "}
                  <button className="btn btn-sm btn-danger badu-destructive" onClick={() => famAct(f, "delete")}>
                    Sil
                  </button>
                </td>
              </tr>
            ))}
          />
        </>
      ) : (
        <>
          <Tabs value={state} onChange={(s) => { setState(s); setPage(1); }} tabs={[["active", "Evli"], ["pending", "Teklif bekleyen"], ["ended", "Biten"]]} />
          <Table
            loading={loading}
            head={["Çift", "Yüzük", "Aşk puanı", "Tarih", "Durum", ""]}
            rows={(data.marriages || []).map((m) => (
              <tr key={m._id}>
                <td>
                  <div className="d-flex align-items-center" style={{ gap: 10 }}>
                    <Person image={m.proposerImage} name={m.proposerName} />
                    <span>❤</span>
                    <Person image={m.partnerImage} name={m.partnerName} />
                  </div>
                </td>
                <td>
                  {m.ringName} ({fmt(m.ringCoin)})
                </td>
                <td>{fmt(m.loveScore)}</td>
                <td>{when(m.marriedAt || m.createdAt)}</td>
                <td>{m.state === "active" ? <Chip>Evli</Chip> : m.state === "pending" ? <Chip kind="wait">Bekliyor</Chip> : <Chip kind="bad">Bitti</Chip>}</td>
                <td>
                  {m.state !== "ended" && (
                    <button className="btn btn-sm btn-danger badu-destructive" onClick={() => endMarriage(m)}>
                      Sonlandır
                    </button>
                  )}
                </td>
              </tr>
            ))}
          />
        </>
      )}
      <Pager page={page} size={20} total={data.total || 0} onChange={setPage} />
    </>
  );
};

export default SocialAdmin;
